export default "__VITE_ASSET__DMCKnUPI__"